'use client';
var closeOnEscape = function(action, options) {
    if (options === void 0) options = {
        active: true
    };
    if (typeof action !== "function" || !options.active) {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return options.onKeyDown || function() {};
    }
    return function(event) {
        if (event.key === "Escape") {
            action(event);
            options.onTrigger == null ? void 0 : options.onTrigger.call(options);
        }
    };
};

export { closeOnEscape };
